import { createAsyncThunk } from "@reduxjs/toolkit";
import apiEndpoints from "../../const/apiEndpoints";
import history from "../../const/history";
import ROUTES from "../../const/routes";
import api from "../../services";
import { AssignLearnSessionPayload, SessionPayload } from "./types";

export const getLearnSession = createAsyncThunk(
    'session/getSession',
    async (): Promise<any> => {
        const response = await api.get(apiEndpoints.getLearnSession)
        return response?.data
    }
)

export const sessionNameApi = createAsyncThunk(
    'session/postSession',
    async (requestPayload: SessionPayload): Promise<any> => {
        const response = await api.post(`${apiEndpoints.sessionPost}`, requestPayload)
        if (response?.data) {
            history.push(ROUTES.ASSIGNLEARN_SESSION)
        }
        return response?.data
    }
)

export const assignSessionlist = createAsyncThunk(
    'session/assignSession',
    async (requestPayload: AssignLearnSessionPayload): Promise<any> => {
        const response = await api.post(`${apiEndpoints.assignSession}`, requestPayload)
        if (response?.data) {
            history.push(ROUTES.LEARN_SESSION)
        }
        return response?.data
    }
)

export const getClearCourse = createAsyncThunk(
    'session/getSession',
    async (): Promise<any> => {
        const response = await api.get(apiEndpoints.clearCourse)
        return response?.data
    }
)

export const getClearMaterial = createAsyncThunk(
    'session/getSession',
    async (): Promise<any> => {
        const response = await api.get(apiEndpoints.clearMaterialCache)
        return response?.data
    }
)